import React, { useState, useEffect } from "react";
import './classes/SalespersonSidebar.css';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Link from '@mui/material/Link';
 import { configData } from "../config";

const SalespersonSidebar = ({ updateToggle, drupal_uid}) => {
  const [masquerade, setMasquerade] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
    const [searchValue, setSearchValue] = useState('');
     const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
    const [options, setOptions] = useState([]);
    const [salespersonactivity, setSalespersonActivity] = useState([]);
    const app_url = configData.APP_URL;
    useEffect(() => {
         
            const mask = localStorage.getItem('masquerade');
           
            if(mask === 1) {
             
              setMasquerade(true);
            } else {
              
              setMasquerade(false);
            }
    }, []);
    useEffect(() => {
      
      getsalespersonactivity();
      getuserloggedinroles();
    // Implement debouncing here if needed
    const fetchData = async () => {
      if (searchValue.trim() === '') {
        setOptions([]); // Clear options if search is empty
        return;
      }
      try {
        // Replace with your actual API call
        const response = await fetch(app_url+'user/getapplicationuserlist?query='+searchValue);
        const data = await response.json();
        setOptions(data.data.result); // Assuming data is an array of objects for Autocomplete
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const handler = setTimeout(() => {
      fetchData();
    }, 500); // Debounce for 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);
  
  const renderOption = (props, option) => (
  <li {...props}>
    <Link href={option.link} color="inherit" underline="hover">
      {option.label}
    </Link>
  </li> 
);

const getOptionLabel = (option) => option.label;

const onChange = (event, newValue) => {
  if (newValue && newValue.link) {
    window.location.href = newValue.link;
  }
};
async function getsalespersonactivity() {
   
         try {
            const response = await fetch(
                app_url+'report/getsalespersonactivity',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonActivity(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
       
  }
  async function getuserloggedinroles() {
   
         try {
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               
               setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
         }
       
  }
    return(
      <>
        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) && (
        <div className="salesperson-right">
            <div id="sidebar-third" className="salesperson-grid_4">
                <div className="salesperson-region salesperson-region-sidebar-third">
                    <div id="block-smww-smww-operations" className="salesperson-block salesperson-block-smww"></div>
                        <div>
                            <h1>Quick Links</h1>
                            <ul>
                                <li className='salesperson-header-hello-text'><a href={"/user/"+localStorage.getItem('uid')+"/edit"} className="salesperson-quick_link_anchor">Manage My Profile</a></li>
                                 {masquerade && (
                                <li>
                                <a href="/smww_pay">
                                <input type="button" className='salesperson-quick-links-reg-button' value="Register for a Course"/>
                                </a>
                                </li>
                                 )}      
                                {masquerade && (
                                    <li>
                                    <a className="salesperson-quick_link_anchor" href={`/miscellaneous/charge/${drupal_uid}`}>
                                        Miscellaneous Charge
                                    </a>
                                    </li>
                                )}
                                <li><a href={"/user/"+localStorage.getItem('uid')}>Dashboard Home</a></li>
                                <li><a href="/my_sales_tasks">My Tasks</a></li>
                                <li><a href="/app-list">Applications</a></li>
                                <li><a href="/salesperson/create/application">Add Application</a></li>
                                {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) && 
                                <li><a target="_blank" href={configData.DRUPAL_DOMAIN_URL+"/user/login"}>Manage Website</a></li>
                                }
                                
                            </ul>
                        </div>
                        <div>
                            <h1>Applicant & Agent Search</h1>
                         <Autocomplete
                                 id="user_search"
                                disablePortal
                                options={options}
                                sx={{ width: 300 }}
                                renderOption={renderOption}
                                getOptionLabel={getOptionLabel}
                                onChange={onChange}
                                 renderInput={(params) => <TextField {...params} onChange={(event) => setSearchValue(event.target.value)}/>}
                               />
                        </div>
                        <div>
                            <h1>Daily Salesperson Activity</h1>
                            <div className="salespeople-content">
                                <div className="salesperson-activity-graph-wrapper">
                                    {salespersonactivity.length > 0 &&
                                    <>
                                   {salespersonactivity.map((item, idx) => (
                                    <div key={item['name']}>
                                        <div className="salespeople-members">
                                        <b>{item['name']}</b>
                                        </div>
                                        <div className="salesperson-progress-full-width">
                                        <div
                                            className={`salesperson-progress-bar salesperson0${idx + 1}`}
                                            style={{ width: item['percent']+'%'}}
                                        >
                                            {item['event_count']}
                                        </div>
                                        </div>
                                        <div className="salesperson-event-count-right">{item['event_count']}</div>
                                        <div className="salesperson-clearfix"></div>
                                    </div>
                                    ))}
                                    </>
                                    }
                                    <p>*The number of users the salesperson has contacted or updated each day</p>
                                </div>
                            </div>
                        </div>
                       
                </div>
            </div>
        </div>
                                  )}  </>
    );
};

export default SalespersonSidebar;